<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 0.5C4 0.5 4.72006 1.19702 5.14974 1.375C5.57941 1.55298 6.47487 1.52513 6.47487 1.52513C6.47487 1.52513 6.44568 2.46579 6.625 2.89871C6.80432 3.33164 7.5 4 7.5 4C7.5 4 6.80123 4.62947 6.625 5.05492C6.44877 5.48038 6.47487 6.47487 6.47487 6.47487C6.47487 6.47487 5.54672 6.43063 5.07747 6.625C4.60823 6.81937 4 7.5 4 7.5C4 7.5 3.0702 6.69753 2.89509 6.625C2.47006 6.44894 1.52513 6.47487 1.52513 6.47487C1.52513 6.47487 1.56245 5.50748 1.375 5.05492C1.18755 4.60237 0.5 4 0.5 4C0.5 4 1.27705 3.31649 1.4501 2.89871C1.62315 2.48094 1.52513 1.52513 1.52513 1.52513C1.52513 1.52513 2.4776 1.54793 2.89509 1.375C3.31258 1.20207 4 0.5 4 0.5Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.01877 3.30005L3.63087 4.81413L3 4.12591"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
